import React, { Component } from 'react';
import moment from 'moment';
import styles from './detail.module.scss';
import classnames from 'classnames';

import API from '../../components/utils/API';
import SSE from '../../components/utils/SSE'
import { strings } from '../../components/utils/translations';
import { Utils } from '../../components/utils/utils';
import Error from '../../components/Error/error';
import EventIcon from '../../img/icons/EventIcon';
import DownloadIcon from '../../img/icons/DownloadIcon';
import RemoteIcon from '../../img/icons/RemoteIcon';
import { ReactComponent as ProximityIcon } from '../../img/icons/proximity_thin.svg';
import { ReactComponent as MicIcon } from '../../img/icons/microphone.svg';
import { ReactComponent as ComputerIcon } from '../../img/icons/computer_purple.svg';
import { ReactComponent as CarIcon } from '../../img/icons/car_sport_purple.svg';
import PrimaryButton from '../../components/Buttons/primaryButton';
import Alert from '../../components/Alert/alert';
import DownloadActivityModal from '../../components/Modal/downloadActivityModal';
import Loader from '../../components/Loader'
import RefreshArrowIcon from '../../img/icons/refresh_arrow.svg'
import VRExpirationTag from '../../components/VRExpirationTag/VRExpirationTag'

const ACTIVITY_CIRCUIT_CLOSED = "CIRCUIT_CLOSED";
const ACTIVITY_CIRCUIT_OPENED = "CIRCUIT_OPENED";
const ACTIVITY_TRIGGER_DOOR = "TRIGGER_DOOR";
const CAMERA_RECORDING = "CAMERA_RECORDING";

const TRIGGER_PROXIMITY_SUGGESTION = 2;
const TRIGGER_PROXIMITY_AUTOMATIC = 3;
const TRIGGER_ALEXA = 5;
const TRIGGER_GOOGLE_ASSISTANT = 6;
const TRIGGER_SIRI = 7;
const TRIGGER_FORD = 9;
const TRIGGER_WEBAPP = 12;
const TRIGGER_TESLA = 13;
const TRIGGER_CARPLAY = 14;
const TRIGGER_ANDROID_AUTO = 15;
const TRIGGER_ANDROID_AUTOMOTIVE = 16;

const INITIAL_ACTIVITY_LIMIT = 20

const SSE_PROD = "https://sse.homyhub.com:8889"
const SSE_LABS = "https://devapp.homyhub.com:8889"
var SSE_URL = null

export default class DetailActivity extends Component
{
	pagesLoaded = 0
    noMoreActivity = false
	
	constructor(props)
	{
		super(props);

		this.state =
		{
			doorId: props.id,
			doorName: props.doorName,
			activitySections: [],
			actions: [],
			isRefreshing: false,
			firstTimeLoad: true,

			showAlert: false,
            alertMessage: null,
			alertColor: null,

			filterType: 'activities',
			filterDate: 'all days',

			openDownloadModal: false,

			limitTo: 15,
            error: false,
            errorText: ''
		}
		
		this.trackScrolling = this.trackScrolling.bind(this)
		this.onLiveEventReceived = this.onLiveEventReceived.bind(this)
		
		SSE_URL = API.isProd() ? SSE_PROD : SSE_LABS
	}
	componentDidMount()
	{
		if (this.props.isVRexpired != true)
			this.loadDoorActivity()
	}
	componentWillUnmount()
	{
  		document.querySelector('.tabsContainer > .ant-tabs > .ant-tabs-content-holder').removeEventListener('scroll', this.trackScrolling)
		
		this.unsubscribeToLiveEvents()
	}
	
	componentDidUpdate(prevProps, prevState)
	{
		if (this.props.id !== prevState.doorId)
		{
			this.pagesLoaded = 0
		    this.noMoreActivity = false
			
			this.unsubscribeToLiveEvents(prevState.doorId)
			this.loadDoorActivity()
		}
	}
	static getDerivedStateFromProps(props, state)
	{
		let newState = {}
		
		if (props.id !== state.doorId)
		{
			newState.doorId = props.id
			newState.activitySections = []
			newState.firstTimeLoad = true
		}
		
		if (props.doorName !== state.doorName)
		{
			newState.doorName = props.doorName
		}
		
		return newState
	}

	render()
	{
		const csvData = JSON.stringify(this.state.activitySections)

		return (
			<div className={classnames(styles.activityContainer, this.props.isVRexpired ? styles.expired : null)}>
			{
				this.props.isVRexpired ?
				<VRExpirationTag
					door={this.props.door}
					bigTag
					biggerTag
				/>
				:
				<>
					{
						(this.state.showAlert) &&
						<Alert
							text={this.state.alertMessage}
							color={this.state.alertColor ? this.state.alertColor : 'red'}
							onClick={() => this.setState({ showAlert: !this.state.showAlert}) }
						/>
					}
					{
						(this.state.activitySections.length > 0) &&
						<div className={styles.activityContent}>
							<div className={styles.refreshFeedContainer} onClick={this.onClickReloadFeed.bind(this)}>
								{
									this.state.isRefreshing ?
									<Loader spinner gray />
									:
									<img
										src={RefreshArrowIcon}
										className={styles.icon}
									/>
								}
							</div>
							
							{ this.renderActivities() }
						</div>
					}
					
					{
						this.state.isRefreshing &&
						<Loader
							spinner
							fullWidth
							gray
							centerHorizontal
							large
							className={styles.activitySpinner}
						/>
					}

					{
						(this.state.activitySections.length == 0 && !this.state.isRefreshing) &&
						<div className={styles.noActivityContainer}>
							<div className={styles.noActivityContent}>
								<h3 className={styles.title}>{ strings('noActivity') }</h3>
								<p className={styles.text}>{ strings('noActivityMessage') }</p>
							</div>
						</div>
					}

					{
						(this.state.activitySections.length > 0) &&
						<div className={styles.downloadBox} onClick={() => this.setState({ openDownloadModal: true })}>
							<DownloadIcon colorLines="#8333FF" colorBackground="#FFF" />
							<div className={styles.content}>
								<h4 className={styles.title}>{ strings('download') }</h4>
								<div className={styles.subtitle}>{ strings('inCsv') }</div>
							</div>
						</div>
					}

					{
						(this.state.openDownloadModal) &&
						<div className={styles.overlay}>
							<DownloadActivityModal
								id={this.state.doorId}
								doorName={this.state.doorName}
								data={this.state.activitySections}
								onClickClose={() => this.setState({ openDownloadModal: false })}
							/>
						</div>
					}
				</>
			}
			</div>
		);
	}

	renderActivities()
	{		
		return (
			this.state.activitySections.map((item, i) =>
	        {
	            return (
	                <div key={item.title} className={styles.activitySection}>
	                    <div className={styles.titleContainer}>
	                        <div className={styles.title}>
	                            { item.title }
	                        </div>
	                    </div>
	                    <div>
	                        {
	                            item.activity.map((item, i) =>
	                            {
	                                return this.renderActivityItem(item, i)
	                            })
	                        }
	                    </div>
	                </div>
	            )
	        })
		)
	}
	renderActivityItem(item, i)
    {
        let sentence = '';
        let image = null
        
        if (item.type === ACTIVITY_CIRCUIT_CLOSED)
            sentence = strings('doorClosed')
        else if (item.type === ACTIVITY_CIRCUIT_OPENED)
            sentence = strings('doorOpen')
        else if (item.type === ACTIVITY_TRIGGER_DOOR)
        {
            sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoor') }</span>;
            
            if (item.subType != null)
            {
                if (item.subType === TRIGGER_PROXIMITY_SUGGESTION)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorSuggestedProximity') }</span>;
                else if (item.subType === TRIGGER_PROXIMITY_AUTOMATIC)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorAutomaticProximity') }</span>;
                else if (item.subType === TRIGGER_ALEXA)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorAlexa') }</span>;
                else if (item.subType === TRIGGER_GOOGLE_ASSISTANT)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorGoogleAssistant') }</span>;
                else if (item.subType === TRIGGER_SIRI)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorSiri') }</span>;
                else if (item.subType === TRIGGER_FORD)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorFord') }</span>;
				else if (item.subType === TRIGGER_WEBAPP)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorWeb') }</span>;
				else if (item.subType === TRIGGER_CARPLAY)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorCarplay') }</span>;
				else if (item.subType === TRIGGER_ANDROID_AUTO)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorAndroidAuto') }</span>;
				else if (item.subType === TRIGGER_ANDROID_AUTOMOTIVE)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorAndroidAutomotive') }</span>;
				else if (item.subType === TRIGGER_TESLA)
                    sentence = <span><span className={styles.fw600}>{ item.name }</span> { strings('triggeredTheDoorTesla') }</span>;
                
                if (item.subType === TRIGGER_PROXIMITY_SUGGESTION ||
                    item.subType === TRIGGER_PROXIMITY_AUTOMATIC)
                    image = <ProximityIcon className={classnames(styles.image, styles.proximity)} />
                else if (item.subType === TRIGGER_ALEXA ||
                         item.subType === TRIGGER_GOOGLE_ASSISTANT ||
                         item.subType === TRIGGER_SIRI)
                    image = <MicIcon className={classnames(styles.image, styles.voiceAssistant)} />
                else if (item.subType === TRIGGER_FORD ||
						 item.subType === TRIGGER_CARPLAY ||
					 	 item.subType === TRIGGER_ANDROID_AUTO ||
					 	 item.subType === TRIGGER_ANDROID_AUTOMOTIVE ||
					 	 item.subType === TRIGGER_TESLA)
                    image = <CarIcon className={classnames(styles.image, styles.car)} />
				else if (item.subType === TRIGGER_WEBAPP)
                    image = <ComputerIcon className={classnames(styles.image, styles.computer)} />
            }
        }
        else if (item.type === CAMERA_RECORDING)
        {
            sentence = (item.name != null) ?
                        <span><span className={styles.fw600}>{ item.name }</span> { strings('recordedTheDoor') }</span>
                        :
                        <span>{ strings('theDoorHasBeen') } <span className={styles.fw600}>{ strings('recordedAutomatically') }</span></span>
        }
            
        return (
            <div key={item.date} className={classnames(styles.activityItem, {[styles.liveEvent]: item.isLiveEvent })}>
                <div className={styles.time}>{ item.date.format('HH:mm') }</div>
                <div className={styles.circleContainer}>
                    {
                        (item.type === CAMERA_RECORDING) ?
                        <div
                            className={styles.videoThumb}
                            style={{ backgroundImage: `url(${item.thumbnailUrl})` }}
                        />
                        :
                        <div className={classnames(
                                        {
                                            [styles.circle]: true,
                                            [styles.red]: (item.type === ACTIVITY_CIRCUIT_CLOSED),
                                            [styles.green]: (item.type === ACTIVITY_CIRCUIT_OPENED),
                                            [styles.trigger]: (item.type === ACTIVITY_TRIGGER_DOOR)
                                        })}
                        >
                            {
                                (image != null) ?
                                image
                                :
                                <div className={styles.initials}>{ Utils.getInitials(item.name) }</div>
                            }
                        </div>
                    }
                </div>
                <div className={styles.message}>{ sentence }</div>
                
                <div className={styles.line}></div>
            </div>
        );
    }

	loadDoorActivity()
    {
        this.setState({ isRefreshing: true }, () =>
        {
            API.getInstance()
			.getDoorEventsAndActions(
			{
				doorId: this.state.doorId,
				limit: INITIAL_ACTIVITY_LIMIT,
				skip: INITIAL_ACTIVITY_LIMIT*this.pagesLoaded
			})
            .then(res =>
            {
                if (res.data.eventsAndActions.actions.length === 0 &&
                    res.data.eventsAndActions.sensor.length === 0 &&
                    res.data.eventsAndActions.recordings.length === 0)
                {
                    this.noMoreActivity = true
                    this.setState({ isRefreshing: false, firstTimeLoad: false })
                    return
                }
                
                let activitySections = Utils.mergeActionsAndSensors(this.state.activitySections, res.data.eventsAndActions)
                
                this.pagesLoaded++

				if (this.state.firstTimeLoad)
					this.subscribeToDoorLiveEvents()
					
                this.setState({ activitySections, isRefreshing: false, firstTimeLoad: false }, () =>
                {
					document.querySelector('.tabsContainer > .ant-tabs > .ant-tabs-content-holder').addEventListener('scroll', this.trackScrolling)
                })
            })
            .catch(err =>
            {
                console.log(err)
                this.setState({ isRefreshing: false })
            })
        })
    }

	sendTriggerDoor()
	{
		API.getInstance().triggerDoor(this.state.doorId)
		.then(response =>
		{
			if (response.status == 200)
			{
				this.getDoorEventsAndActions();
			}
			else
			{
				setTimeout(() =>
                {
                    this.setState({
                        showAlert: true,
                        alertMessage: strings('doorTriggerError'),
                    });
                }, 2000);
			}
		})
		.catch(error =>
		{
			console.log(error);

			setTimeout(() =>
            {
                this.setState({
                    showAlert: true,
                    alertMessage: strings('doorTriggerError'),
                });
            }, 2000);
		});
	}
	trackScrolling()
	{
  		const el = document.querySelector('.tabsContainer > .ant-tabs > .ant-tabs-content-holder')
		if (el.offsetHeight + el.scrollTop >= el.scrollHeight)
		{
			el.removeEventListener('scroll', this.trackScrolling)
			
			if (!this.state.isRefreshing && !this.noMoreActivity)
            	this.loadDoorActivity()
		}
	}
	onClickReloadFeed()
	{
		if (this.state.isRefreshing) return
		
		this.unsubscribeToLiveEvents()
		
		this.pagesLoaded = 0
		this.noMoreActivity = false
		this.setState({ activitySections: [], firstTimeLoad: true }, () =>
		{
			this.loadDoorActivity()
		})
	}
	
	subscribeToDoorLiveEvents()
	{
		SSE.getInstance().subscribeToDoorEvents(this.state.doorId, this.onLiveEventReceived)
	}
	onLiveEventReceived(data)
	{
		if (data.actionType != null && data.actionType === "TRIGGER_DOOR")
		{
			let activitySections = Utils.mergeActionsAndSensors(this.state.activitySections, { actions: [{...data, isLiveEvent: true}] })
			this.setState({ activitySections })
		}
		else if (data.sensorId != null)
		{
			let eventType = (data.value === 0) ? ACTIVITY_CIRCUIT_CLOSED : ACTIVITY_CIRCUIT_OPENED
			let activitySections = Utils.mergeActionsAndSensors(this.state.activitySections, { sensor: [{...data, isLiveEvent: true, eventType}] })
			this.setState({ activitySections })
		}
		else if (data.clipUrl != null)
		{
			let activitySections = Utils.mergeActionsAndSensors(this.state.activitySections, { recordings: [{...data, isLiveEvent: true}] })
			this.setState({ activitySections })
		}
	}
	unsubscribeToLiveEvents(doorId)
	{
		let finalDoorId = (doorId == null) ? this.state.doorId : doorId
		SSE.getInstance().unsubscribeToDoorEvents(finalDoorId, this.onLiveEventReceived)
	}
}
